
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.985 8.707C19.849 4.431 15.988 0 9.958 0 7.11 0 4.506 1.135 2.628 3.182.725 5.255-.223 8.02.032 10.97.467 16.01 4.759 20 9.755 20h.02c1.605-.004 2.31-1.576 1.408-2.719-.69-.876-.498-1.526-.293-1.91.349-.653.894-.957 1.718-.959.731 0 1.484.011 2.205-.035 3.173-.202 5.275-2.428 5.172-5.67zM2.368 7.691c0-.97.788-1.758 1.757-1.758.97 0 1.758.789 1.758 1.758A1.76 1.76 0 014.125 9.45a1.76 1.76 0 01-1.757-1.758zm2.343 6.446a1.76 1.76 0 01-1.758-1.758c0-.97.789-1.758 1.758-1.758.97 0 1.758.788 1.758 1.758a1.76 1.76 0 01-1.758 1.758zm2.93-8.204a1.76 1.76 0 01-1.758-1.757c0-.97.789-1.758 1.758-1.758.97 0 1.758.788 1.758 1.758A1.76 1.76 0 017.64 5.933zm4.688 0a1.76 1.76 0 01-1.758-1.757c0-.97.788-1.758 1.758-1.758.969 0 1.757.788 1.757 1.758a1.76 1.76 0 01-1.758 1.757zm3.515 3.516a1.76 1.76 0 01-1.758-1.758c0-.97.789-1.758 1.758-1.758.97 0 1.758.789 1.758 1.758a1.76 1.76 0 01-1.758 1.758z"}})])
          )
        }
      }
    